<template>
  <section class="category-page-section bulletin-list-page-section popular-category-section">
    <div class="wrapper">
      <div class="col-lg-12 col-md-12 col-sm-12 mt-4">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="title-banner detail-title-banner">
              <div class="title-content">
                <h1 class="detail-head">{{ translations.bulletin }}</h1>
                <div class="address-section">
                  <p class="footer-add">
                    <router-link to="/">
                      {{ translations.home_lite }}
                    </router-link>
                  </p>
                  <img
                    src="../assets/images/next-page.svg"
                    alt="next-icon"
                    class="next-page"
                    loading="lazy"
                  />
                  <p class="footer-add">{{ translations.bulletin }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="main mt-4">
        <div :class="{
          'categories_head-tamil-fonts': selectedLanguage === 'ta',
          categories_head_En: selectedLanguage !== 'ta',
        }">
          <h2 :class="{
            'popular-tamil-fonts': selectedLanguage === 'ta',
            'popular-title': selectedLanguage !== 'ta',
          }">
            {{ translations.bulletin }}
          </h2>
        </div>

        <div class="categories">
          <div
            @click="selectType('all')"
            :class="{ active: selectedType === null }"
          >
            <p :class="{
              'filter-tamil-fonts': selectedLanguage === 'ta',
              'filter-title': selectedLanguage !== 'ta',
            }">
              {{ translations.all }}
            </p>
          </div>

          <div
            @click="selectType('buy')"
            :class="{ active: selectedType === 'buy' }"
          >
            <p :class="{
              'filter-tamil-fonts': selectedLanguage === 'ta',
              'filter-title': selectedLanguage !== 'ta',
            }">
              {{ translations.buy }}
            </p>
          </div>

          <div
            @click="selectType('harvest')"
            :class="{ active: selectedType === 'harvest' }"
          >
            <p :class="{
              'filter-tamil-fonts': selectedLanguage === 'ta',
              'filter-title': selectedLanguage !== 'ta',
            }">
              {{ translations.harvest }}
            </p>
          </div>
        </div>
      </div>

      <div class="row mb-4" v-if="displayBulletins.length > 0">
        <div v-if="isLoading" class="loader mt-4">
          <div class="row">
            <div
              v-for="n in 8"
              :key="n"
              class="col-lg-3 col-md-4 col-sm-12"
            >
              <p class="shimmer-line-img"></p>
              <p class="shimmer-line"></p>
              <p class="shimmer-line"></p>
            </div>
          </div>
        </div>

        <div
          v-else
          class="col-lg-3 col-md-4 col-sm-12"
          v-for="bulletin in displayBulletins"
          :key="bulletin.id"
        >
          <div class="product" @click="openBulletinDetail(bulletin)">
            <div class="img_div">
              <img
                :src="bulletin.image"
                :alt="`Bulletin ${bulletin.id}`"
                loading="lazy"
                @error="handleImageError"
              />
            </div>

            <p
              :class="{ 'type_tamil': selectedLanguage === 'ta', 'type': selectedLanguage !== 'ta' }"
              :style="{
                backgroundColor: bulletin.type === 'buy' ? '#B0C800' : 'lightskyblue',
              }"
            >
              {{ getTypeLabel(bulletin.type, bulletin.typeNormalized) }}
            </p>

            <div class="align">
              <div class="category-level-row">
                <p :class="{ 'sub_category_name_tamil': selectedLanguage === 'ta', 'sub_category_name': selectedLanguage !== 'ta' }">
                  {{ bulletin.categoryNormalized }}
                </p>
                <p
                  v-if="bulletin.levelNormalized"
                  class="bulletin-level-normalized"
                  :class="getLevelClass(bulletin.level)"
                >
                  {{ bulletin.levelNormalized }}
                </p>
              </div>

              <p class="product-name">{{ bulletin.productName }}</p>

              <div class="date-location">
                <div>
                  <p :class="{ 'location_name_d_tamil': selectedLanguage === 'ta', 'loction-data_d': selectedLanguage !== 'ta' }">
                    <span>
                      <img
                        src="../assets/images/location-icon.svg"
                        alt="location"
                        loading="lazy"
                      />
                    </span>
                    {{ getLocationText(bulletin) }}
                  </p>
                </div>
                <div>
                  <p class="created">{{ formatDate(bulletin.createdAt) }}</p>
                </div>
              </div>

              <div class="price-view">
                <div>
                  <p :class="{ 'price_tamil': selectedLanguage === 'ta', 'price': selectedLanguage !== 'ta' }">
                    {{ getPriceText(bulletin) }}
                  </p>
                </div>
                <div>
                  <button :class="{ 'price_button_tamil': selectedLanguage === 'ta', 'price_button': selectedLanguage !== 'ta' }">
                    {{ translations.viewmore }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else>
        <div v-if="isLoading" class="loader mt-4">
          <div class="row">
            <div
              v-for="n in 8"
              :key="n"
              class="col-lg-3 col-md-4 col-sm-12"
            >
              <p class="shimmer-line-img"></p>
              <p class="shimmer-line"></p>
              <p class="shimmer-line"></p>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="nodata-img">
            <img
              src="../assets/images/emptypro.webp"
              loading="lazy"
              alt="empty"
            />
          </div>
          <h2 class="my-3 no-data">Bulletin Data Not Available!!</h2>
          <p class="no-data-para">
            We're sorry, Please check back later. You can browse our website to find
            alternative bulletins.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import { en, ta } from "../translations.js";

const FALLBACK_IMAGE = require("../assets/images/No-Data-list.webp");
const API_BASE_URL = "https://vaiyal-app.herokuapp.com";

export default {
  name: "BulletInListComponent",
  props: {
    selectedLanguage: String,
  },
  data() {
    return {
      isLoading: false,
      selectedType: null,
      bulletinData: [],
    };
  },
  computed: {
    translations() {
      return this.selectedLanguage === "en" ? en : ta;
    },
    displayBulletins() {
      if (!this.selectedType) {
        return this.bulletinData;
      }

      return this.bulletinData.filter((item) => item.type === this.selectedType);
    },
  },
  watch: {
    "$route.query.type"(newType, oldType) {
      if (newType === oldType) return;
      const normalizedType = this.normalizeType(newType);
      if (normalizedType === this.selectedType) return;
      this.selectedType = normalizedType;
      this.fetchBulletinList();
    },
  },
  created() {
    this.selectedType = this.normalizeType(this.$route.query.type);
    this.fetchBulletinList();
  },
  mounted() {
    this.scrollToTop();
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    normalizeType(value) {
      const type = String(value || "").toLowerCase();
      return type === "buy" || type === "harvest" ? type : null;
    },
    selectType(type) {
      const normalizedType = type === "all" ? null : type;
      if (normalizedType === this.selectedType) {
        return;
      }
      this.selectedType = normalizedType;
      this.syncTypeQuery();
      this.fetchBulletinList();
    },
    syncTypeQuery() {
      const query = { ...this.$route.query };
      if (this.selectedType) {
        query.type = this.selectedType;
      } else {
        delete query.type;
      }

      this.$router.replace({ name: "BulletInList", query }).catch(() => {});
    },
    async fetchBulletinList() {
      this.isLoading = true;
      try {
        const params = {};
        if (this.selectedType) {
          params.type = this.selectedType;
        }

        const response = await axios.get(`${API_BASE_URL}/listbulletin`, { params });
        const list = Array.isArray(response?.data?.data) ? response.data.data : [];
        this.bulletinData = list.map(this.mapBulletinItem);
      } catch (error) {
        console.error("Error while fetching bulletin list:", error);
        this.bulletinData = [];
      } finally {
        this.isLoading = false;
      }
    },
    mapBulletinItem(item) {
      return {
        id: item.id,
        type: String(item.type || "").toLowerCase(),
        typeNormalized: item.type_normalized || this.getTypeLabel(item.type),
        level: String(item.level || "").toLowerCase(),
        levelNormalized: String(item.level_normalized || "").trim(),
        categoryNormalized: item.category_normalized || this.formatCategory(item.category),
        productName: item.product_name || "No Name",
        description: item.description || "",
        districtName: item.district_name || "Tamilnadu",
        districtTamilName: item.district_tn_name || item.district_name || "Tamilnadu",
        placeName: item.place_name || "",
        placeTamilName: item.place_tn_name || item.place_name || "",
        quantity: item.quantity ?? 0,
        price: item.price ?? "",
        quantityType: item.quantity_type || "",
        quantityTypeTamil: item.quantity_type_tamil || item.quantity_type || "",
        image: this.getPrimaryImage(item),
        createdAt: item.created_at,
      };
    },
    getPrimaryImage(item) {
      const imageUrls = this.getImageUrls(item);
      return imageUrls[0] || FALLBACK_IMAGE;
    },
    getImageUrls(item) {
      const rawImages = item?.image_url ?? item?.ImageUrl;

      if (Array.isArray(rawImages)) {
        return rawImages.filter(Boolean);
      }

      if (typeof rawImages === "string" && rawImages.trim()) {
        return [rawImages];
      }

      return [];
    },
    formatCategory(value) {
      if (!value) return "N/A";
      return value
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
      });
    },
    getTypeLabel(type, normalized = "") {
      if (normalized) return normalized;
      const normalizedType = String(type || "").toLowerCase();
      if (normalizedType === "buy") return this.translations.buy;
      if (normalizedType === "harvest") return this.translations.harvest;
      return "N/A";
    },
    getLevelClass(level) {
      const value = String(level || "").toLowerCase();
      if (value === "urgent") return "level-urgent";
      if (value === "needed") return "level-needed";
      if (value === "required") return "level-required";
      return "level-default";
    },
    getQuantityType(item) {
      if (this.selectedLanguage === "ta") {
        return item.quantityTypeTamil || item.quantityType;
      }

      return item.quantityType;
    },
    hasValidPrice(price) {
      const normalized = String(price ?? "").trim();
      return normalized !== ""; // && normalized !== "0" && normalized !== "00";
    },
    getPriceText(item) {
      if (!this.hasValidPrice(item.price)) {
        return this.translations.prnm || this.translations.priceNotMentioned;
      }

      const quantityType = this.getQuantityType(item);
      return quantityType ? `₹${item.price}/${quantityType}` : `₹${item.price}`;
    },
    getLocationText(item) {
      const district =
        this.selectedLanguage === "ta" ? item.districtTamilName : item.districtName;
      const place = this.selectedLanguage === "ta" ? item.placeTamilName : item.placeName;

      if (place) {
        return `${place}, ${district}`;
      }

      return district;
    },
    handleImageError(event) {
      event.target.src = FALLBACK_IMAGE;
    },
    openBulletinDetail(item) {
      const route = this.getBulletinRoute(item);
      window.open(this.$router.resolve(route).href, "_blank");
    },
    getBulletinRoute(bulletin) {
      return {
        name: "BulletinDetail",
        params: {
          location: this.formatRouteSegment(bulletin.districtName, "tamilnadu"),
          category: "bulletins",
          categoryName: this.formatRouteSegment(bulletin.categoryNormalized, "bulletin"),
          bulletin: this.formatRouteSegment(
            bulletin.productName || bulletin.categoryNormalized,
            "bulletin"
          ),
          id: String(bulletin.id),
        },
      };
    },
    formatRouteSegment(value, fallback = "item") {
      const normalized = String(value || "")
        .trim()
        .toLowerCase()
        .replace(/&/g, " and ")
        .replace(/[^a-z0-9\s-]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "");

      return normalized || fallback;
    },
  },
};
</script>

<style scoped>
@import url("/src/components/CategoryPage.scss");
@import url("/src/components/BulletInComponent.scss");

.bulletin-list-page-section {
  margin-top: 0;
  margin-bottom: 0;
}
</style>
